import { Route, Routes } from "react-router-dom";
import { AboutPage } from "../../components/AboutPage";
import { CareersPage } from "../../components/CareersPage";
import { ContactPage } from "../../components/ContactPage";
import { EventsPage } from "../../components/EventsPage";
import { FacilityPage } from "../../components/FacilityPage";
import { FaqPage } from "../../components/FaqPage";
import { Homepage } from "../../components/Homepage";
import { MembershipsPage } from "../../components/MembershipsPage";
import { PrivacyPolicyPage } from "../../components/PrivacyPolicyPage";
import { ProgramDetailPage, ProgramsPage } from "../../components/ProgramsPage";
import { RentalsPage } from "../../components/RentalsPage";
import { TechnologyPage } from "../../components/TechnologyPage";
import { TermsPage } from "../../components/TermsPage";
import { SchedulePage } from "../../components/SchedulePage";
import { PaymentsPage } from "../../components/PaymentsPage";
import { SettingsRoute } from "../../components/SettingsRoute";
import { GuestSessionBookingPage } from "../checkout/pages/GuestSessionBookingPage";
import { GuestBookingConfirmationPage } from "../checkout/pages/GuestBookingConfirmationPage";

export function WebsiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/facility" element={<FacilityPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/rentals" element={<RentalsPage />} />
      <Route path="/technology" element={<TechnologyPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/memberships" element={<MembershipsPage />} />
      <Route path="/programs" element={<ProgramsPage />} />
      <Route path="/programs/:slug" element={<ProgramDetailPage />} />
      <Route path="/schedule" element={<SchedulePage />} />
      <Route path="/book-session/confirmed" element={<GuestBookingConfirmationPage />} />
      <Route path="/book-session/:sessionId" element={<GuestSessionBookingPage />} />
      <Route path="/payments" element={<PaymentsPage />} />
      <Route path="/settings" element={<SettingsRoute />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
    </Routes>
  );
}
